import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import CompareCheckbox from './CompareCheckbox.jsx';
import uiLocale from '../../../utils/UILocale.js';
import { convertProductToAjaxAPIProductFormat } from './helpers';

const translations = {
  tooltipText: uiLocale.getString('component.comparecheckbox.please_remove_product'),
  checkboxLabel: uiLocale.getString('component.comparepanel.compare_button') ||
    uiLocale.getString('component.compare.compareCountLabel'),
  defaultLabel: uiLocale.getString('component.comparepanel.upToItems')
};

function getProductFromDigitalData(productId) {
  const products = window.digitalData.products || [];
  let foundProduct = products.find(
    (product) => product.productID === productId
  );
  if (foundProduct) {
    foundProduct = convertProductToAjaxAPIProductFormat(foundProduct);
  }
  return foundProduct;
}

function initCompareCheckboxes() {
  let checkboxPlaceholders = document.querySelectorAll('[data-component="compare-checkbox"]');
  checkboxPlaceholders = Array.from(checkboxPlaceholders);

  const compareForm = document.querySelector('form[data-component="compareForm"]');
  let tooltipArrowDirection;

  // Tooltip arrow direction is different on list view and grid view.
  if (document.querySelector('div.resultList') ||
    document.getElementById('video-with-compare-checkbox')) {
    tooltipArrowDirection = 'bottom';
  } else {
    tooltipArrowDirection = 'top';
  }

  checkboxPlaceholders.forEach((mountEl) => {

    let product = null;

    // checkbox on PDP
    if (checkboxPlaceholders.length === 1) {
      product = convertProductToAjaxAPIProductFormat(window.digitalData.product[0]);
    } else {
    // checkboxes on PLP
      const productId = mountEl.getAttribute('data-productid');
      if (!productId) {
        return;
      }
      product = getProductFromDigitalData(productId);
    }

    if (product) {

      ReactDOM.render(
        <Provider store={window.appState}>
          <CompareCheckbox
            tooltipArrowDirection={tooltipArrowDirection}
            containerFormEl={compareForm}
            product={product}
            translations={translations}
          />
        </Provider>,
        mountEl
      );
    }
  });
}

export default initCompareCheckboxes;
